export default __webpack_public_path__ + "assets/33abb120a5e5150f96f757f3446be58e.png";